import React from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { setReturnTo } from "../lib/returnTo";
import AuthSessionLoader from "./AuthSessionLoader";

function isPaymentCompleteRoute(pathname) {
  return /^\/book\/[^/]+\/complete$/.test(pathname) || /^\/parking\/[^/]+\/complete$/.test(pathname);
}

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { user, loading, authError } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const paymentCompleteRoute = isPaymentCompleteRoute(location.pathname);
  const returnPath = location.pathname + (location.search || "");

  if (loading) {
    return (
      <AuthSessionLoader
        message="Authenticating…"
        testId="protected-loading"
      />
    );
  }
  if (!user) {
    if (authError && paymentCompleteRoute) {
      return (
        <AuthSessionLoader
          message="Authenticating…"
          testId="protected-auth-error"
          secondaryAction={{
            label: "Sign in to continue",
            testId: "protected-sign-in-btn",
            onClick: () => {
              setReturnTo(returnPath);
              navigate("/login", { state: { authRequired: true } });
            },
          }}
        />
      );
    }
    // Persist the path (incl. query) so we can resume after sign-in.
    setReturnTo(returnPath);
    return <Navigate to="/login" replace state={{ authRequired: true }} />;
  }
  if (requireAdmin && !user.is_admin) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
